// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__37O65","bigColWidth":"Table_bigColWidth__1cQFn","biggerColWidth":"Table_biggerColWidth__1wsob","row":"Table_row__1LmkG","col":"Table_col__2QFGE"};